import { useEffect, useState } from 'react';
import FJLikeIcon from '../../../../assets/svg/community/like.svg?react';
import FJLikedIcon from '../../../../assets/svg/community/liked.svg?react';
import FJUtil from '../../../../util/FJUtil';
import styles from './FJLikeIconComponent.module.less';
import PropTypes from 'prop-types';
const FJLikeIconComponent = props => {
    const { isLike, likeNum, onLikeClick } = props;
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (!isAnimating) return;
        const timer = setTimeout(() => setIsAnimating(false), 220);
        return () => clearTimeout(timer);
    }, [isAnimating]);

    const _onLikeClick = e => {
        FJUtil.forbidEvent(e);
        setIsAnimating(true);
        onLikeClick && onLikeClick(!isLike);
    };
    return (
        <div className={styles.box} onClick={_onLikeClick}>
            <div className={`${styles.like_icon} ${isAnimating ? styles.like_icon__animate : ''}`}>
                {isLike ? <FJLikedIcon /> : <FJLikeIcon />}
            </div>
            <div className={styles.like_num}>{FJUtil.getAbbrNumber(likeNum, '+')}</div>
        </div>
    );
};
FJLikeIconComponent.propTypes = {
    isLike: PropTypes.bool.isRequired,
    likeNum: PropTypes.number.isRequired,
    onLikeClick: PropTypes.func.isRequired,
};
export default FJLikeIconComponent;
